import { Eye, EyeOff, Lock, Mail, Shield } from 'lucide-react'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../utils/AuthContext'

function Login() {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log('Form submitted with data:', formData);
    
    if (!formData.username || !formData.password) {
      console.log('Missing username or password');
      return;
    }
    
    setLoading(true)
    console.log('Setting loading to true');
    
    try {
      const result = await login(formData)
      console.log('Login result:', result);
      
      if (result.success) {
        navigate('/dashboard')
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false)
      console.log('Setting loading to false');
    }
  }

  return (
    <div className="min-h-screen bg-black flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="absolute inset-0 opacity-10">
        <div className="matrix-bg"></div>
      </div>
      <div className="relative sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Shield className="h-12 w-12 text-green-400" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold font-mono text-green-400">
          <span className="text-green-500">&gt;</span> Sign in to CyberSafe
        </h2>
        <p className="mt-2 text-center text-sm text-gray-300 font-mono">
          Don't have an account?{' '}
          <Link to="/register" className="font-mono text-blue-400 hover:text-blue-300 transition-colors">
            Register here
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md relative z-10">
        <div className="bg-gray-900 border border-green-500/30 py-8 px-4 shadow-lg sm:rounded-lg sm:px-10 relative">
          <form className="space-y-6" onSubmit={handleSubmit} id="login-form">
            <div>
              <label htmlFor="username" className="block text-sm font-mono text-green-400 mb-2">
                Username or Email
              </label>
              <div className="relative">
                <input
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="username"
                  required
                  className="w-full pl-10 pr-3 py-2 bg-black border border-green-500/30 rounded-md text-green-400 placeholder-gray-500 font-mono focus:outline-none focus:border-green-500/50 focus:bg-gray-900/50"
                  placeholder="Enter username or email"
                  value={formData.username}
                  onChange={handleChange}
                />
                <Mail className="absolute left-3 top-2.5 h-5 w-5 text-green-500" />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-mono text-green-400 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  required
                  className="w-full pl-10 pr-10 py-2 bg-black border border-green-500/30 rounded-md text-green-400 placeholder-gray-500 font-mono focus:outline-none focus:border-green-500/50 focus:bg-gray-900/50"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <Lock className="absolute left-3 top-2.5 h-5 w-5 text-green-500" />
                <button
                  type="button"
                  className="absolute right-3 top-2.5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-green-500" />
                  ) : (
                    <Eye className="h-5 w-5 text-green-500" />
                  )}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-green-600 bg-black border-green-500/30 rounded focus:ring-green-500"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-300 font-mono">
                  Remember me
                </label>
              </div>

              <div className="text-sm">
                <a href="#" className="font-mono text-blue-400 hover:text-blue-300">
                  Forgot password?
                </a>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="btn w-full bg-green-600/20 hover:bg-green-600/40 text-green-400 hover:text-green-300 py-3 px-4 rounded-md font-mono transition-all duration-300 border border-green-600/30 hover:border-green-500/50 flex justify-center items-center cursor-pointer relative z-10 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-green-400"></div>
                ) : (
                  <>
                    <span className="text-green-500">[</span>Sign in<span className="text-green-500">]</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login